module.exports = __webpack_public_path__ + "img/ylcs1.55477fb0.png";